import script from "./approvalDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./approvalDetail.vue?vue&type=script&setup=true&lang=js"

import "./approvalDetail.vue?vue&type=style&index=0&id=96cfc41c&scoped=true&lang=css"

import exportComponent from "/jenkins/workspace/rk-storeroom-webui_feature_1.0.1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96cfc41c"]])

export default __exports__